<template>
    <div class="apikeyDetail">
        <van-nav-bar v-if="$route.query.isApp != 1" title="我的API key" left-arrow @click-left="$router.go(-1)" />
        <div class="commont_body">
            <div class="page-item">
                <div class="item-top">
                    <div class="item-title">
                      <!-- 创建时间 -->
                        <span class="title">{{$t('9100162')}}</span>
                        <span>{{ parseTimeData(pageData.createTime) }}</span>
                    </div>
                    <div class="item-title">
                      <!-- 备注名 -->
                        <span class="title">{{$t('9100128')}}</span>
                        <span>{{ pageData.note }}</span>
                    </div>
                </div>
                <div class="item-line"></div>
                <div class="item-top">
                    <div class="item-title">
                      <!-- 9100142 权限-->
                        <span class="title">{{$t('9100142')}}</span>
                        <!-- 9100131  读取 -->
                        <!-- 交易 -->
                        <span>{{$t('9100131')}}{{ pageData.freeSpotState ? "、"+ $t('9100132') : "" }}</span>
                    </div>
                    <div class="item-title">
                      <!-- 到期时间 9100165-->
                        <span class="title">{{$t('9100165')}}</span>
                        <span>{{ parseTimeData(pageData.expirationTime || "") ? parseTimeData(pageData.expirationTime || "") : '--' }}</span>
                    </div>
                </div>
                <div class="item-line"></div>
                <div class="item-top">
                    <div class="item-title" style="width: 100%;">
                        <span class="title">Access Key</span>
                        <div class="content">
                            <span>{{ pageData.accessKey }} </span>
                            <!-- im -->
                            <i @click="handleCopy" :data-clipboard-text="pageData.accessKey" class="copy iconfont icon-fuzhi"></i>
                        </div>
                    </div>
                </div>

                <div class="item-line"></div>
                <div class="item-top">
                    <div class="item-title" style="width: 100%;">
                      <!-- 9100143 绑定IP地址 -->
                        <span class="title">{{$t('9100143')}}</span>
                        <div class="content">
                            <!-- <span>{{ pageData.accessKey }} </span> -->
                            <span>{{ pageData.whiteList || "--" }}</span>
                            <!-- im -->
                            <!-- <i
                @click="handleCopy"
                :data-clipboard-text="pageData.accessKey"
                class="copy iconfont icon-fuzhi"
              ></i> -->
                        </div>
                    </div>
                </div>
                <div class="item-line"></div>
            </div>
        </div>
        <div class="flot">
          <!-- 9100166  删除 -->
            <Button @click="showDelete = true" color="rgba(255, 199, 43, 0.05)" class="delect">{{$t('9100166')}}</Button>
            <!-- 编辑 -->
            <Button @click="goEditApiKey" color="#FFC72B">{{$t('9100164')}}</Button>
            <!-- 续签 -->
            <Button @click="showNextAPI = true" color="#FFC72B" v-if="!pageData.whiteList">{{$t('9100144')}}</Button>
        </div>

        <van-popup class="tipModel" :close-on-click-overlay="false" v-model="showDelete">
            <p class="modal-title">
                <!-- 确认删除当前API Key？ -->
                {{$t('9100150')}}
            </p>

            <div class="modal-content">
                <!-- 确认删除当前API Key？ -->
                {{$t('9100150')}}
            </div>

            <div class="sell">
                <Button class="cancel" @click="showDelete = false" color="rgba(0, 0, 0, 0.10)">
                  <!-- 取消 -->
                  {{$t('300111')}}
                </Button>
                <Button @click="confirmDelete" :loading="delectLoading" color="#FFC72B">
                  <!-- 确认 -->
                  {{$t('300287')}}
                </Button>
            </div>
        </van-popup>

        <van-popup class="tipModel" :close-on-click-overlay="false" v-model="showNextAPI">
            <p class="modal-title">
                <!-- 确认续签当前API Key？ -->
                {{$t('9100146')}}
            </p>

            <div class="modal-content">
                <!-- 续签后到期时间会重新计算。如您长期使用API Key，建议绑定IP地址，绑定后API
                Key不会失效同时也更加安全。 -->
                {{$t('9100149')}}
            </div>

            <div class="sell">
              <!-- 300111  取消 -->
                <Button class="cancel" @click="showNextAPI = false" color="rgba(0, 0, 0, 0.10)">{{$t('300111')}}</Button>
                <!-- 确认 -->
                <Button @click="confirmNextApi" :nextLoading="nextLoading" color="#FFC72B">{{$t('300287')}}</Button>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {
        List,
        Icon,
        NavBar,
        Button,
        Collapse,
        CollapseItem,
        Toast,
        Popup
    } from "vant";
    import { parseTime } from "@/utils/index";
    import { getListdata } from "@/api/resource";
    import { Empty } from "vant";
    import { mapGetters } from "vuex";
    import { removeApiKey, queryApiKey, continueApiKey } from "@/api/apikey";
    import Clipboard from "clipboard";
    import { setToken, getCookie, removeToken, setCookie } from '../../utils/auth'
    export default {
        name: "apiKey",
        components: {
            vanList: List,
            vanIcon: Icon,
            vanEmpty: Empty,
            vanNavBar: NavBar,
            Button,
            [Collapse.name]: Collapse,
            [CollapseItem.name]: CollapseItem,
            vanPopup: Popup
        },
        data() {
            return {
                pageData: {},
                showDelete: false,
                showNextAPI: false,
                delectLoading: false,
                nextLoading: false,
            };
        },
        computed: {
            ...mapGetters(["isDirection"])
        },
        methods: {
            resher() {
                this.isApp = this.$route.query.isApp
                let token = this.$route.query.token || this.token
                if (token) {
                    setToken(token);
                    this.$store.dispatch('GetInfo', token);
                    this.$store.dispatch('setToken', token);
                }
                this.$i18n.locale = this.$route.query.language ? this.$route.query.language : 'en'
                setCookie(
                    'language',
                    this.$route.query.language ? this.$route.query.language : 'en'
                )
                this.language = this.$route.query.language
                    ? this.$route.query.language
                    : 'en'
                this.$store.dispatch(
                    'setIsDirection',
                    this.$route.query.language == 'fa' ? true : false
                )
                if (this.$route.query.backgroundColor != "") {
                    window.document.documentElement.setAttribute(
                        "data-theme",
                        this.$route.query.backgroundColor === "day" ? "sunlight" : "moon"
                    );
                } else {
                    window.document.documentElement.setAttribute("data-theme", "moon");
                }
                window.document.documentElement.setAttribute(
                    'dir',
                    this.isDirection ? 'rtl' : 'ltr'
                )
            },
            async getPageList() {
                const { data } = await queryApiKey();
                this.pageData =
                    (data && data.length && data.find(i => i.id == this.$route.query.id)) ||
                    [];
            },
            parseTimeData(item) {
                return item ? parseTime(item) : null;
            },
            handleCopy() {
                var clipboard = new Clipboard(".copy");
                clipboard.on("success", e => {
                    Toast(this.$t('300027'));
                    // 释放内存
                    clipboard.destroy();
                });
                clipboard.on("error", e => {
                    Toast.fail(this.$t("300028"));
                    // 释放内存
                    clipboard.destroy();
                });
            },
            goEditApiKey(){
              // $router.push('/createKey?id=' + pageData.id) 
              this.$router.push({
                    path: `/createKey`,
                    query: {
                        id: this.$route.query.id,
                        backgroundColor: this.$route.query.backgroundColor,
                        language:this.$route.query.language,
                        isApp:this.$route.query.isApp,
                    }
                });
            },
            async confirmDelete() {
                this.delectLoading = true;
                const res = await removeApiKey(this.pageData.id)
                this.showDelete = false;
                this.delectLoading = false;
                Toast(res.msg);
                this.$router.go(-1);
            },
            async confirmNextApi() {
                this.nextLoading = true;
                const res = await continueApiKey(this.pageData.id);
                this.showNextAPI = false;
                this.nextLoading = false;
                this.getPageList();
                Toast(res.msg);
            }
        },
        watch: {
            $route() {
                this.resher()
            },
        },
        created() {
            console.log(this.$route.query,'this.$route.query---this.$route.query');
            this.resher()
            this.getPageList();
        },
        // mounted(){
        //     document.addEventListener('touchmove', function (e) {
        //         e.preventDefault();
        //     }, { passive: false });
        // },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/css/variableName";
    @import "../../style/mixin";
    @import "../../assets/css/mixin";

    .apikeyDetail {
        width: 100%;
        height: 100vh;
        overflow: hidden;
        @include background_color("background-color-2");
        /deep/ .van-nav-bar__content {
            @include background_color("background-color-10");
            height: torem(44);
        }
        /deep/ .van-nav-bar__title {
            @include font_color("font-color");
            // color: red;
        }
        /deep/ .van-nav-bar .van-icon {
            @include font_color("font-color");
        }
        /deep/ .van-hairline--bottom::after{
            @include border_color("border-color-6");
        }
        .page-item {
            padding: torem(20) torem(16);
            margin-bottom: torem(16);

            .item-line {
                width: 100%;
                border-bottom: 2px solid rgba(0, 0, 0, 0.03);
                margin: torem(20) 0;
            }
            .item-top {
                display: flex;
                align-items: center;
                .item-title {
                    width: 48%;
                    display: flex;
                    flex-direction: column;
                    // color: rgba(0, 0, 0, 0.9);
                    @include font_color("font-color");

                    font-family: "HarmonyOS Sans SC";
                    font-size: torem(12);
                    font-style: normal;
                    font-weight: 500;
                    line-height: normal;
                    .title {
                        @include font_color("disale-color");
                        font-family: "HarmonyOS Sans SC";
                        font-size: torem(10);
                        font-style: normal;
                        font-weight: 500;
                        line-height: normal;
                        margin-bottom: torem(12);
                    }
                    .content {
                        display: flex;
                        width: 100%;
                        justify-content: space-between;
                        align-items: center;
                        span {
                            width: 90% !important;
                            white-space: wrap !important;
                            word-break: break-all;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2; /* 控制显示的行数 */
                        }
                    }
                    span {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
        .flot {
            position: fixed;
            bottom: 0;
            width: 100%;
            // background-color: #fff;
            @include background_color("background-color-2");
            display: flex;
            justify-content: space-between;
            padding: torem(24) torem(8);

            button {
                // width: calc(33% - 0.2rem);
                margin: 0 0.4rem;
                flex: 1;
                color: #000 !important;
            }
            // /deep/ .van-button__text {
            // }
            .delect {
                border-radius: 8px;
                color: #d9a31a !important;
                border: 2px solid #d9a31a !important;
                /deep/ .van-button__text {
                    color: #D9A31A !important;
                }
            }
        }
    }

    .tipModel {
        // /deep/ .van-popup {
        width: calc(100% - 2rem);
        // min-height: torem(204);
        border-radius: torem(8);
        padding: torem(24);
        @include background_color("background-color-2");

        .modal-title {
            display: flex;
            align-items: center;
            @include font_color("font-color");

            font-family: "HarmonyOS Sans SC";
            font-size: torem(16);
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            // justify-content: center;
        }
        .modal-content {
            display: flex;
            flex-direction: column;
            @include font_color("font-color");

            font-feature-settings: "clig" off, "liga" off;
            font-family: "HarmonyOS Sans SC";
            font-size: torem(14);
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 42px */
            margin: torem(24) 0;
            div {
                margin: torem(4) 0;
            }
        }
        .sell {
            width: 100%;
            display: flex;
            justify-content: space-between;
            button {
                // flex: 1;
                width: 48% !important;
                height: torem(48);
                // margin:0 torem(12);
            }
            .cancel /deep/ .van-button__text{
              // @include background_color("background-color-5");
              @include font_color("font-color");
            }
        }
    }

    /deep/ .van-button__text {
        color: #000;
    }
    // D9A31A
</style>



// WEBPACK FOOTER //
// src/view/apiKey/apikeyDetail.vue